<template>
	<tab_header icon="fa-solid fa-computer" title="Logs" />

	<label for="show-most-recent" class="fw-bold">
		<input
			v-model="show_most_recent_logs"
			name="show-most-recent"
			id="show-most-recent"
			type="checkbox" />
		Mostrar mais recente
	</label>
	<div class="row mt-3">
		<div class="col-12">
			<div
				class="console-output-logs"
				style="max-height: 500px; overflow: scroll; background: black">
				<pre class="p-2" style="color: #dddddd" v-html="logs"></pre>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import tab_header from './tab_header.vue';
	import WebsocketComputerLogs from '../../websockets/WebsocketComputerLogs';
	import { Ref, computed, ref } from 'vue';

	const props = defineProps({
		logs_websocket_url: { type: String, required: true },
	});

	const arrayLogs: Ref<Array<string>> = ref([]);

	const show_most_recent_logs = ref(true);

	const websocket = new WebsocketComputerLogs(
		props.logs_websocket_url
	).connectWs();

	websocket.onmessage = (message) => {
		processLogs(message.data);
	};

	function processLogs(message) {
		const logMessage = JSON.parse(message);
		const datetime = moment
			.unix(logMessage.ts)
			.format('DD/MM/YYYY HH:mm:ss');
		const msg = logMessage.msg as string;
		arrayLogs.value.unshift(
			`<p class="m-0 p-0 text-white">${logMessage.level.toUpperCase()} ${datetime}> ${msg}</p>`
		);
	}

	const logs = computed(() => {
		return show_most_recent_logs.value
			? arrayLogs.value.join('')
			: arrayLogs.value.slice().reverse().join('');
	});
</script>
